<template>
  <span class="wit" :class="`wit--${type}`">
    <v-icon x-small class="wit__icon">{{ icon }}</v-icon>
    {{ $t(`waste_item_type_${type}`) }}
  </span>
</template>

<script>
// type is one of simple | variant | recipe | ingredient — the same values as
// stock_waste_details.item_type, which decides which stock a line moves.
const ICONS = {
  simple: "fal fa-box",
  variant: "fal fa-layer-group",
  recipe: "fal fa-utensils",
  ingredient: "fal fa-flask",
};

export default {
  name: "WasteItemTypeTag",
  props: {
    type: { type: String, required: true },
  },
  computed: {
    icon() {
      return ICONS[this.type] || ICONS.simple;
    },
  },
};
</script>

<style scoped>
.wit {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 1px 8px;
  border: 1px solid var(--app-border);
  border-radius: 999px;
  background: var(--app-field-bg);
  color: var(--app-text-primary);
  font-size: 11px;
  font-weight: 600;
  line-height: 1.6;
  white-space: nowrap;
}

.wit__icon {
  color: var(--app-text-secondary) !important;
}

.wit--variant {
  border-color: var(--app-info-soft-border);
  background: var(--app-info-soft-bg);
}

.wit--recipe {
  border-color: var(--app-warning-soft-border);
  background: var(--app-warning-soft-bg);
}

.wit--ingredient {
  border-color: var(--app-success-soft-border);
  background: var(--app-success-soft-bg);
}
</style>
